import { render, staticRenderFns } from "./ConnectMindbody.vue?vue&type=template&id=605ee156&scoped=true&"
import script from "./ConnectMindbody.vue?vue&type=script&lang=js&"
export * from "./ConnectMindbody.vue?vue&type=script&lang=js&"
import style0 from "./ConnectMindbody.vue?vue&type=style&index=0&id=605ee156&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605ee156",
  null
  
)

export default component.exports